import { onBeforeUnmount, onMounted, type Ref, ref } from 'vue';

import {
  getLargeScreenMatchMedia,
  getSmallScreenMatchMedia,
  getTabletScreenMatchMedia,
} from '@/helpers/browser';

export interface MediaContext {
  isSmallScreen: Ref<boolean | null>;
  isLargeScreen: Ref<boolean | null>;
  isTabletScreen: Ref<boolean | null>;
}

export const useMedia = (): MediaContext => {
  const isSmallScreen = ref<boolean | null>(null);
  const isLargeScreen = ref<boolean | null>(null);
  const isTabletScreen = ref<boolean | null>(null);

  const isSmallScreenListener = (e: { matches: boolean }) => (isSmallScreen.value = !e.matches);
  const isLargeScreenListener = (e: { matches: boolean }) => (isLargeScreen.value = e.matches);
  const isTabletScreenListener = (e: { matches: boolean }) => (isTabletScreen.value = e.matches);

  let smallScreenMedia: MediaQueryList;
  let largeScreenMedia: MediaQueryList;
  let tabletScreenMedia: MediaQueryList;

  onMounted(() => {
    smallScreenMedia = getSmallScreenMatchMedia();
    smallScreenMedia.addEventListener('change', isSmallScreenListener);

    isSmallScreenListener(smallScreenMedia);

    largeScreenMedia = getLargeScreenMatchMedia();
    largeScreenMedia.addEventListener('change', isLargeScreenListener);

    isLargeScreenListener(largeScreenMedia);

    tabletScreenMedia = getTabletScreenMatchMedia();
    tabletScreenMedia.addEventListener('change', isTabletScreenListener);

    isTabletScreenListener(tabletScreenMedia);
  });

  onBeforeUnmount(() => {
    smallScreenMedia.removeEventListener('change', isSmallScreenListener);
    largeScreenMedia.removeEventListener('change', isLargeScreenListener);
    tabletScreenMedia.removeEventListener('change', isTabletScreenListener);
  });

  return { isSmallScreen, isLargeScreen, isTabletScreen };
};
